<template lang="pug">
div.bg-light.min-vh-100
  app-main-menu

  app-main-content.py-4
    .container
      .card-header.p-4.bg-white.rounded-top
        .row.row-sm.align-items-center
          .col
            h4.mb-0 Settings

      .card.border-0.rounded-0.rounded-bottom
        .p-4
          h5.mb-4 Change Password
          change-password
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ChangePassword from './ChangePassword.vue';
import AppMainMenu from '@/components/AppMainMenu.vue';

export default defineComponent({
  name: 'Settings',
  components: { 
    ChangePassword,
    AppMainMenu
  },
});
</script>

<style lang="scss" scoped>
.bg-light {
  background-color: #f8f9fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
